import React, { useState } from 'react';
import { firestore } from '../firebase/firebase';

const StudentRegistration = () => {
  const [name, setName] = useState('');
  const [course, setCourse] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Add student registration to Firestore
      await firestore.collection('registrations').add({
        name,
        course,
      });
      alert('Registration successful!');
      // Optionally, clear the form fields
      setName('');
      setCourse('');
    } catch (error) {
      console.error('Error registering student:', error);
    }
  };

  return (
    <div>
      <h2>Student Course Registration</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Course"
          value={course}
          onChange={(e) => setCourse(e.target.value)}
        />
        <button type="submit">Register</button>
      </form>
    </div>
  );
};

export default StudentRegistration;
